import React from "react";
import SearchManage from "../../../Components/GMS/Search/Manage";

function Search(props) {
    return <SearchManage props={props} />;
}

export default Search;
